//const latpayDomain = "dev.latpay.net";
const latpayDomain = "latpay.net";

export default latpayDomain;